import { render, staticRenderFns } from "./supplemental_branches.vue?vue&type=template&id=4a91a606&"
import script from "./supplemental_branches.vue?vue&type=script&lang=js&"
export * from "./supplemental_branches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports